import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { IQueryFormat } from '../enums/types';
import { IAdvertising, IAdvertising_P, IAdvertising_S } from '../interfaces/IAdvertising';
import { IAdvertisingMarquee, IAdvertisingMarquee_P, IAdvertisingMarquee_S } from '../interfaces/IAdvertisingMarquee';
import { ISliderImgHome, ISliderImgHome_P, ISliderImgHome_S } from '../interfaces/ISliderImgHome';
import { LoginDialogComponent } from "../login-dialog/login-dialog.component";
import { NgForOf, NgIf } from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import { AdvertisingMarqueeService } from '../service/advertising-marquee.service';
import { AdvertisingService } from '../service/advertising.service';
import { ProductsService } from "../service/products.service";
import { environment } from "../../environments/environment";
import { IProducts } from "../interfaces/IProducts";
import { TooltipModule } from "primeng/tooltip";
import { ECollection } from "../enums/ECollection";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { FeedbackService } from "../service/feedback.service";
import { NotificationService } from "../service/notification.service";
import { AuthService } from "../service/auth.service";
import { EventS } from "../service/event.s";
import { SliderImgHomeService } from '../service/slider-img-home.service';
import { DialogModule } from "primeng/dialog";

declare var $: any;

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [LoginDialogComponent, NgForOf, RouterLink, TooltipModule, ReactiveFormsModule, DialogModule, NgIf],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
    specialEventsDialog = false;
    products: IProducts[] = [];
    feedback: any[] = [];
    fileUrl = environment.FILE_URL;
    typerLoaded = false;
    destroyed = false;
    getTouchForm: FormGroup;
    getSubscribeForm: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    sliderImagesArr: ISliderImgHome[] = [];
    advertisingArr: IAdvertising[] = [];
    advertisingMarqueeArr: IAdvertisingMarquee[] = [];

    constructor(public productsService: ProductsService,
                public feedbackService: FeedbackService,
                public advertisingService: AdvertisingService,
                public advertisingMarqueeService: AdvertisingMarqueeService,
                public sliderImgHomeService: SliderImgHomeService,
                public eventS: EventS,
                private cd: ChangeDetectorRef,
                private authService: AuthService,
                private ns: NotificationService,
                private fb: FormBuilder,
                private router: Router,) {
        this.getTouchForm = this.fb.group({
            name: ['', Validators.required],
            email: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
            city: ['', Validators.required],
            productName: ['', Validators.required],
            contactNumber: <any>['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
            message: ['', Validators.required],
        });

        this.getSubscribeForm = this.fb.group({
            subscribeEmail: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
        });
    }

    async ngOnInit() {
        setTimeout(() => {
            this.getProducts().then();
            this.getCustomerFeedback().then();
            this.loadSliderImage().then();
            this.loadAdvertising().then();
            this.loadAdvertisingMarquee().then();
        }, 500);

        // always load typer script if not loaded
        if (!(window as any).typerJs) {
            const script = document.createElement('script');
            script.src = "https://unpkg.com/typer-dot-js@0.1.0/typer.js";
            script.onload = () => {
                this.typerLoaded = true;
                this.initTyper();
            };
            document.head.appendChild(script);
        } else {
            this.typerLoaded = true;
            this.initTyper();
        }
        // setTimeout(() => {
        //     this.specialEventsDialog = true;
        // }, 0);
    }

    ngAfterViewInit(): void {
        // this.initMainCarousel();
        this.initFeedbackCarousel();
    }

    async loadSliderImage() {
        // this.loading = true;
        this.sliderImagesArr = [];
        let query = <IQueryFormat>{
            find: <ISliderImgHome_P>{
                active: true,
            },
            select: <ISliderImgHome_S>{
                order: 1,
                mps_url_arr: 1,
                mps_name_str: 1,
            },
            sort: <ISliderImgHome_S>{ order: 1 },
        };
        let resp = await this.sliderImgHomeService.query(query);
        if (resp && resp.length) for (let item of resp) item.fileUrl = `${this.fileUrl}${item.mps_url_arr[0].uploadPath}`;
        this.sliderImagesArr = resp;
        // this.loading = false;
        setTimeout(() => {
            if (this.destroyed) return;

            if (typeof $ === 'undefined') return;
                if (this.destroyed) return;
                $('#owl-carousel-10').owlCarousel({
                    items: 1,
                    loop: true,
                    nav: false,
                    margin: 0,
                    autoplay: true,
                    autoplayTimeout: 4000,
                    slideTransition: 'linear',
                    autoplayHoverPause: false,
                    dots: false,
                    responsiveClass: true,
                    responsive: {
                        0: { items: 1 },
                        600: { items: 1 },
                        1030: { items: 1 },
                        1280: { items: 1 },
                        1920: { items: 1 }
                    }
                });
        }, 0);
        this.cd.detectChanges();
    }

    async loadAdvertising() {
        this.specialEventsDialog = false;
        // this.loading = true;
        this.advertisingArr = [];
        let query = <IQueryFormat>{
            find: <IAdvertising_P>{
                active: true,
            },
            select: <IAdvertising_S>{
                order: 1,
                mpa_name_str: 1,
                mpa_url_arr: 1,
            },
            sort: <IAdvertising_S>{ order: 1 },
        };
        let resp = await this.advertisingService.query(query);
        if (resp && resp.length) for (let item of resp) item.fileUrl = `${this.fileUrl}${item.mpa_url_arr[0]?.uploadPath}`;
        this.advertisingArr = resp.filter((el: IAdvertising_P) => el?.mpa_url_arr?.length);
        if (this.advertisingArr?.length) this.specialEventsDialog = true;
        this.owlCarousel3().then();
        // this.loading = false;
        this.cd.detectChanges();
    }

    async loadAdvertisingMarquee() {
        // this.loading = true;
        this.advertisingMarqueeArr = [];
        let query = <IQueryFormat>{
            find: <IAdvertisingMarquee_P>{
                active: true,
            },
            select: <IAdvertisingMarquee_S>{
                order: 1,
                mpam_name_str: 1,
                mpam_description_str: 1,
            },
            sort: <IAdvertisingMarquee_S>{ order: 1 },
        };
        let resp = await this.advertisingMarqueeService.query(query);
        this.advertisingMarqueeArr = resp;
        // this.loading = false;
        this.cd.detectChanges();
    }

    ngOnDestroy() {
        this.destroyed = true;
    }

    async onSubmit() {
        if (this.getTouchForm.valid) {
            await this.sendEmail();
            this.getTouchForm.reset();
            this.ns.showSuccess("Mail Sent Successfully.");
        } else alert("Please enter valid data.");
    }

    async sendEmail() {
        let contact = this.getTouchForm.value;
        await this.productsService.sendContactMail(contact);
    }

    // ✅ Initialize typer
    initTyper() {
        setTimeout(() => {
            if (this.destroyed) return;
            const el = document.getElementById('mainHeaderTyping');
            if (el && (window as any).typerJs) {
                try {
                    // reset before re-init (important on logout/login navigation)
                    el.innerHTML = '';
                    (window as any).typerJs.init();
                } catch (e) {
                    console.error('Typer init error:', e);
                }
            }
        }, 200);
    }

    // ✅ Initialize main carousel
    // initMainCarousel() {
    //     if (typeof $ === 'undefined') return;
    //     setTimeout(() => {
    //         if (this.destroyed) return;
    //         $('#owl-carousel').owlCarousel({
    //             items: 1,
    //             loop: true,
    //             nav: false,
    //             margin: 0,
    //             autoplay: true,
    //             autoplayTimeout: 4000,
    //             slideTransition: 'linear',
    //             autoplayHoverPause: false,
    //             dots: false,
    //             responsiveClass: true,
    //             responsive: {
    //                 0: { items: 1 },
    //                 600: { items: 1 },
    //                 1030: { items: 1 },
    //                 1280: { items: 1 },
    //                 1920: { items: 1 }
    //             }
    //         });
    //     }, 100);
    // }

    // ✅ Load products + init carousel after DOM update
    async getProducts() {
        this.products = await this.productsService.query({
            find: { active: true },
            deep: [
                {
                    s_key: "mpp_productGroup_objid",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_PRODUCT_GROUPS,
                    t_key: "_id",
                    select: { mpg_productGroupImg_arr: 1 }
                }
            ]
        });

        if (this.products?.length) {
            this.products.forEach(item => {
                const img = item.mpp_productGroup_objid?.mpg_productGroupImg_arr?.[0];
                if (img?.uploadPath) {
                    item.fileUrl = `${this.fileUrl}${img.uploadPath}`;
                }
            });
        }

        // 🔑 Force Angular to flush DOM
        this.cd.detectChanges();

        // 🔑 Init carousel after DOM update
        setTimeout(() => {
            if (this.destroyed) return;

            const el2 = $('#owl-carousel-2');
            if (el2 && el2.length) {
                el2.owlCarousel({
                    loop: false,
                    rewind: true,
                    nav: true,
                    margin: 10,
                    autoplay: true,
                    autoplayTimeout: 4000,
                    slideTransition: 'linear',
                    autoplayHoverPause: true,
                    dots: false,
                    responsiveClass: true,
                    responsive: {
                        0: { items: 1 },
                        600: { items: 2 },
                        1030: { items: 3 },
                        1280: { items: 3 },
                        1400: { items: 3 },
                        1700: { items: 3 },
                        1920: { items: 4 }
                    }
                });
            }
        }, 0);
    }

    async owlCarousel3(){
        setTimeout(()=>{
            const el3 = $('#owl-carousel-3');
            if (el3 && el3.length) {
                el3.owlCarousel({
                    loop: true,
                    margin: 12,
                    slideTransition: 'linear',
                    nav: false,
                    autoplay: true,
                    autoplayTimeout: 4000,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 1
                        }
                    }
                });
            }
        },0)
    }

    async getCustomerFeedback() {
        this.feedback = await this.feedbackService.query({
            find: { active: true },
            deep: [
                {
                    s_key: "mpf_name_objectId",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_USERS,
                    t_key: "_id",
                    select: { usr_customerName_str: 1 }
                }
            ]
        });
        // attach file URLs for feedback images
        if (this.feedback?.length) {
            this.feedback.forEach((item: any) => {
                const img = item.mpf_img_arr?.[0];
                if (img?.uploadPath) {
                    item.fileUrl = `${this.fileUrl}${img.uploadPath}`;
                } else {
                    item.fileUrl = "./assets/images/author_photo_1.png"; // fallback
                }
            });
        }

        // flush DOM and init carousel
        this.cd.detectChanges();
        this.initFeedbackCarousel();
    }

    initFeedbackCarousel() {
        if (typeof $ === 'undefined') return;

        setTimeout(() => {
            if (this.destroyed) return;

            const $carousel = $('.feedback-carousel');

            // 🔄 Destroy existing instance before reinit
            if ($carousel.hasClass('owl-loaded')) {
                $carousel.trigger('destroy.owl.carousel');
                $carousel.find('.owl-stage-outer').children().unwrap();
            }

            $carousel.owlCarousel({
                loop: true,
                margin: 24,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                smartSpeed: 650,
                responsive: {
                    0: { items: 1, margin: 16, stagePadding: 0 },
                    576: { items: 1, margin: 20, stagePadding: 0 },
                    768: { items: 2, margin: 20 },
                    1200: { items: 3, margin: 20 }
                }
            });
        }, 200);
    }

    async showProducts() {
        if (!this.authService.gUser?._id) {
            this.ns.showInfo('Please login first to browse products.');
            this.eventS.openLoginDialog.next(true);
            return;
        }
        this.router.navigate(['/product']);
    }
}
